"use strict";

(function () {
  function r(e, n, t) {
    function o(i, f) {
      if (!n[i]) {
        if (!e[i]) {
          var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
        }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
          var n = e[i][1][r];return o(n || r);
        }, p, p.exports, r, e, n, t);
      }return n[i].exports;
    }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
      o(t[i]);
    }return o;
  }return r;
})()({ 1: [function (require, module, exports) {
    'use strict';

    window.$ = window.jQuery;

    window.FontAwesomeConfig = {};

    // require('@fortawesome/fontawesome');
    // require('@fortawesome/fontawesome-pro-solid');
    // require('@fortawesome/fontawesome-pro-regular');
    // require('@fortawesome/fontawesome-pro-light');
    // require('@fortawesome/fontawesome-free-brands');

    // require('./wp-functions.js');

    var slickVerticalScroll = require('./slick-vertical-scroll.js');

    jQuery(document).ready(function ($) {
      // require('./ajax.js');

      function findToggleElements(el) {
        var selector = $(el).data('toggle-target'),
            elements;

        if (selector.charAt(0) === '>') {
          elements = $(el).find(selector.substr(1));
        } else {
          elements = $(selector);
        }

        if (!elements) {
          console.log('No elements found to toggle for selector ' + JSON.stringify(selector));
        }

        return elements;
      }

      $(document).on('click', '[data-toggle-event="click"], [data-toggle-target]:not([data-toggle-event])', function () {
        findToggleElements(this).toggleClass($(this).data('toggle-class'));
      });

      $(document).on('mouseenter', '[data-toggle-event="hover"]', function () {
        findToggleElements(this).addClass($(this).data('toggle-class'));
      });

      $(document).on('mouseleave', '[data-toggle-event="hover"]', function () {
        findToggleElements(this).removeClass($(this).data('toggle-class'));
      });

      $('.w-tab-link:first-child').addClass('w--current').trigger('click');

      $('select.is-select2, .is-select2:not(select) select').select2();

      $('[data-is-sticky], .is-sticky').each(function () {
        if (!$(this).stickySidebar) {
          console.log('Sticky requested but no jQuery.stickySidebar seems to be loaded');
          return;
        }

        var settings = {
          containerSelector: 'body',
          stickyClass: 'w-focus',
          innerWrapperSelector: '.inner-wrapper-sticky'
        };

        [].filter.call(this.attributes, function (attr) {
          return (/^data-sticky/.test(attr.name)
          );
        }).forEach(function (attr) {
          var name = attr.name.replace(/^data-sticky-?/, '').replace(/-[a-z]/g, function (s) {
            return s.charAt(1).toUpperCase();
          }).trim();

          if (!name) {
            return;
          }

          var value = attr.value;

          settings[name] = value;
        });

        console.log('Init stickySidebar with settings ', settings);

        $(this).stickySidebar(settings);

        var children = $(this).find(settings.innerWrapperSelector + ' > *');
        console.log('children', children, settings.innerWrapperSelector + ' > *');

        this.addEventListener('affix.top.stickySidebar', function (e) {
          children.addClass(settings.stickyClass);
        });

        this.addEventListener('affix.bottom.stickySidebar', function (e) {
          children.addClass(settings.stickyClass);
        });

        this.addEventListener('affix.static.stickySidebar', function (e) {
          children.removeClass(settings.stickyClass);
        });
      });

      $('.is-slick, [data-is-slick], [data-slick]').each(function () {
        var settings = {};

        [].filter.call(this.attributes, function (attr) {
          return (/^data-slick/.test(attr.name)
          );
        }).forEach(function (attr) {
          var name = attr.name.replace(/^data-slick-?/, '').replace(/-[a-z]/g, function (s) {
            return s.charAt(1).toUpperCase();
          }).trim();

          if (!name) {
            return;
          }

          var value = attr.value;

          if (typeof value === 'string') {
            value = value.trim();

            try {
              value = eval(value);
            } catch (e) {
              value = attr.value.trim();
            }
          }

          settings[name] = value;
        });

        $(this).children(':not(div)').remove();

        var slides = $(this).children().not('script, :empty');

        var total_slides = slides.length - 1;

        console.log('Init slick with settings', settings, ' on ', this);

        $(this).slick(settings);

        if (!settings.hasOwnProperty('nextArrow')) {
          settings.nextArrow = $(this).find('.slick-next, [data-slick-arrow="next"]');
        }

        if (!settings.hasOwnProperty('prevArrow')) {
          settings.prevArrow = $(this).find('.slick-prev, [data-slick-arrow="prev"]');
        }

        if (settings.scrollMove) {
          slickVerticalScroll(this, settings, total_slides);
        }
      });

      $('[data-datepicker], [data-is-datepicker]').each(function () {
        var settings = {};

        [].filter.call(this.attributes, function (attr) {
          return (/^data-datepicker/.test(attr.name)
          );
        }).forEach(function (attr) {
          var name = attr.name.replace(/^data-datepicker-?/, '').replace(/-[a-z]/g, function (s) {
            return s.charAt(1).toUpperCase();
          }).trim();

          if (!name) {
            return;
          }

          var value = attr.value;

          if (typeof value === 'string') {
            value = value.trim();

            try {
              value = eval(value);
            } catch (e) {
              value = attr.value.trim();
            }
          }

          settings[name] = value;
        });

        settings.field = this;

        console.log('Initializing Pikaday with settings', settings);

        new Pikaday(settings);
      });
    });
  }, { "./slick-vertical-scroll.js": 2 }], 2: [function (require, module, exports) {
    'use strict';

    module.exports = function (slider, settings, total_slides) {
      var deltaTimeout = null,
          deltaY = 0,
          shouldScrollPastSlider = false;

      function scrollSlider(e, currentDeltaY) {

        deltaY += currentDeltaY;

        console.log('current Y:', currentDeltaY, ' y buffer', deltaY);

        if (settings.scrollThreshold) {
          clearTimeout(deltaTimeout);

          deltaTimeout = setTimeout(function () {
            console.log('clearing y buffer');
            deltaY = 0;
          }, 75);

          var offset = $(slider).offset();

          if (offset && $(window).scrollTop() - offset.top >= 10) {
            return;
          }

          if (Math.abs(deltaY) < settings.scrollThreshold) {
            if (!shouldScrollPastSlider) {
              e.preventDefault();
            }

            return;
          }
        }

        var slideTo = function slideTo(s) {
          var current_slide = $(slider).slick('slickCurrentSlide');

          if (s === 'next') {
            if (current_slide < total_slides) {
              shouldScrollPastSlider = false;
              $(slider).slick('slickNext');
              e.preventDefault();
            } else {
              shouldScrollPastSlider = true;
            }
          } else {
            if (current_slide > 0) {
              shouldScrollPastSlider = false;
              $(slider).slick('slickPrev');
              e.preventDefault();
            } else {
              shouldScrollPastSlider = true;
            }
          }
        };

        if (settings.vertical) {
          if (deltaY >= 0) {
            slideTo('next');
          } else {
            slideTo('prev');
          }
        } else {
          if (deltaY < 0) {
            slideTo('next');
          } else {
            slideTo('prev');
          }
        }

        setTimeout(function () {
          deltaY = 0;
        }, 50);

        setTimeout(function () {
          deltaY = 0;
        }, 250);

        setTimeout(function () {
          deltaY = 0;
        }, 500);

        deltaY = 0;
      }

      $(slider).parent().on('wheel', '.slick-initialized.slick-vertical', function (e) {
        scrollSlider(e, e.originalEvent.deltaY);
      });

      var start = { x: 0, y: 0 };

      $(slider).parent().on('touchstart', '.slick-initialized.slick-vertical', function (event) {
        start.x = event.touches[0].pageX;
        start.y = event.touches[0].pageY;
      });

      $(slider).parent().on('touchmove', '.slick-initialized.slick-vertical', function (event) {
        var offset = {};

        offset.x = start.x - event.touches[0].pageX;
        offset.y = start.y - event.touches[0].pageY;

        scrollSlider(event, offset.y);

        return offset;
      });
    };
  }, {}] }, {}, [1]);